import { Configuration as ecomConfig } from '@/gen/ecom/runtime'
import { Configuration as asmEcomConfig } from '@/gen/ecom-asm/runtime'
import { getSelectedOrgUnitId } from '@/helpers/getSelectedOrgUnitId'
import { getCachedSession } from '@/lib/clients/getCachedSession'

import type { ConfigurationParameters } from '@/gen/ecom/runtime'

const AUTH_HEADER = 'www-authenticate'
const DEFAULT_SITE_URL = 'http://localhost:3000'

const ecomConfigParams: ConfigurationParameters = {
  basePath: typeof window !== 'undefined' ? '/api/ecom' : `${DEFAULT_SITE_URL}/api/ecom`,
  middleware: [
    {
      async pre(context) {
        if (typeof window === 'undefined') {
          return
        }

        const session = await getCachedSession()
        const selectedOrgUnitId = getSelectedOrgUnitId(session)

        if (!selectedOrgUnitId) {
          return
        }

        const headers = new Headers(context.init.headers as HeadersInit)
        headers.set('sap-commerce-cloud-customer-id', selectedOrgUnitId)

        return { url: context.url, init: { ...context.init, headers } }
      },
      async post(context) {
        if (
          context?.response.status === 401 &&
          context?.response.headers.has(AUTH_HEADER) &&
          (context?.response.headers.get(AUTH_HEADER)?.includes('Invalid access token') ||
            context?.response.headers.get(AUTH_HEADER)?.includes('Access token expired')) &&
          typeof window !== 'undefined'
        ) {
          window.location.href = '/relogin'
        }
      },
    },
  ],
}

export const ecomConfiguration = new ecomConfig(ecomConfigParams)

const asmEcomConfigParams: ConfigurationParameters = {
  ...ecomConfigParams,
  basePath: ecomConfigParams.basePath?.replace('ecom', 'ecom-asm'),
}
export const ecomAsmConfiguration = new asmEcomConfig(asmEcomConfigParams)
